<template>
  <md-card>
    <md-card-header>
      <h2>Crear nuevo giro empresarial</h2>
    </md-card-header>
    <md-card-content>
      <div class="md-layout">
        <form novalidate class="md-layout-item" id="core_business_form" @submit.prevent="submit">
          <div class="md-layout">
            <div class="md-layout-item md-size-100 md-xsmall-size-100">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <md-field
                  :class="[
                    { 'md-valid': !errors.has('name') && touched.name },
                    { 'md-form-group': true },
                    { 'md-error': errors.has('name') },
                  ]"
                >
                  <md-icon>domain</md-icon>
                  <label>Nombre</label>
                  <md-input
                    v-model="name"
                    data-vv-name="name"
                    type="text"
                    name="name"
                    required
                    v-validate="modelValidations.name"
                  ></md-input>
                  <slide-y-down-transition>
                    <md-icon class="error" v-show="errors.has('name')">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="!errors.has('name') && touched.name">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </div>
            </div>

            <div class="md-layout-item md-size-100 md-xsmall-size-100">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <md-field
                  :class="[
                    { 'md-valid': !errors.has('code') && touched.code },
                    { 'md-form-group': true },
                    { 'md-error': errors.has('code') },
                  ]"
                >
                  <md-icon></md-icon>
                  <label>Descripción</label>
                  <md-textarea
                    v-model="code"
                    data-vv-name="code"
                    type="textarea"
                    name="code"
                    required
                    v-validate="modelValidations.code"
                  ></md-textarea>
                  <slide-y-down-transition>
                    <md-icon class="error" v-show="errors.has('code')">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="!errors.has('code') && touched.code">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </div>
            </div>
          </div>
        </form>
      </div>
    </md-card-content>
    <md-card-actions>
      <md-button type="submit" form="core_business_form" class="md-success">Aceptar</md-button>
    </md-card-actions>
  </md-card>
</template>

<script>
import catalogService from "@/services/catalog";
import { SlideYDownTransition } from "vue2-transitions";

const modelValidations = {
  name: {
    required: true,
    min: 3,
  },
  code: {},
};
const touched = {
  name: false,
  code: false,
};

export default {
  name: "RegisterCoreBusiness",
  components: { SlideYDownTransition },
  data() {
    return {
      modelValidations,
      touched,
      name: "",
      code: "",
    };
  },
  methods: {
    submit() {
      this.isValid().then((res) => {
        if (res) {
          catalogService
            .create("core_business", {
              name: this.name,
              description: this.code,
            })
            .then((res) =>
              this.$successMessage({
                title: "Nueno giro empresarial",
                text: "Se ha registrado un nuevo giro empresarial",
              })
            )
            .catch(this.$fireErrorResponse);
        }
      });
    },
    isValid() {
      return this.$validator.validateAll().then((res) => res);
    },
  },
  watch: {
    name() {
      this.touched.name = true;
    },
    code() {
      this.touched.code = true;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/Providers/wizard/RegisterCoreBusiness.vue